// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  gray06,
  primary,
  white,
  blue01,
} from 'presentations/views/styles/color';
import Icon from 'presentations/views/components/atoms/Icon';
import {
  spacing,
  fontSize,
  fontWeight,
  borderRadius,
  mediaMax,
} from 'presentations/views/styles';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useState } from 'react';
import Transition from 'presentations/views/components/atoms/Transition';

interface Props {
  onCopy?: any;
  isCopied?: boolean;
  copiedContent: string;
  title?: string;
  notSetWidthMobileContainer?: boolean;
  mobileIconSize?: string;
  mobileTitleFontSize?: string;
  isHideIcon?: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const onCopy = (text: string, result: boolean) => {
    props.onCopy && props.onCopy(text, result);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 5000);
  };

  return (
    <CopyMenuList>
      <CopyMenuContainer
        notSetWidthMobileContainer={props.notSetWidthMobileContainer}
      >
        <Transition name="collapse" in={isCopied}>
          <CopiedMenuLink>
            <CopyIcon
              name="check"
              fontSize="small"
              color="primary"
              mobileIconSize={props.mobileIconSize}
            />
            <CopyMenuLinkTitle mobileTitleFontSize={props.mobileTitleFontSize}>
              {t('Copied')}
            </CopyMenuLinkTitle>
          </CopiedMenuLink>
        </Transition>
        <CopyToClipboard text={props.copiedContent} onCopy={onCopy}>
          <CopyMenuLink role="button">
            {!props.isHideIcon && (
              <CopyIcon
                name="file_copy_outlined"
                fontSize="small"
                color="primary"
                mobileIconSize={props.mobileIconSize}
              />
            )}
            <CopyMenuLinkTitle mobileTitleFontSize={props.mobileTitleFontSize}>
              {props.title ?? t('Copy Link')}
            </CopyMenuLinkTitle>
          </CopyMenuLink>
        </CopyToClipboard>
      </CopyMenuContainer>
    </CopyMenuList>
  );
}

const CopyMenuList = styled.div`
  height: 52px;
  border-radius: ${borderRadius()};
  overflow: hidden;
  background-color: ${gray06};
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    background-color: ${blue01};
  }
`;

const CopyMenuContainer = styled.div<{
  notSetWidthMobileContainer?: boolean;
}>`
  width: 213px;
  height: 52px;
  ${mediaMax.tablet} {
    width: ${({ notSetWidthMobileContainer }) =>
      notSetWidthMobileContainer ? '213px' : '100%'};
  }
`;

const CopyMenuLink = styled.div`
  height: 52px;
  color: ${primary};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const CopiedMenuLink = styled.div`
  width: 100%;
  height: 52px;
  color: ${primary};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${blue01};
  ${mediaMax.tablet} {
    width: 100%;
  }
`;
const CopyMenuLinkTitle = styled.span<{
  mobileTitleFontSize?: string;
}>`
  margin-left: ${spacing(8)};
  font-size: ${fontSize(13)};
  font-weight: ${fontWeight('bold')};

  ${({ mobileTitleFontSize }) =>
    mobileTitleFontSize &&
    css`
      ${mediaMax.tablet} {
        font-size: ${mobileTitleFontSize};
      }
    `}
`;
const CopyIcon = styled(Icon)<{
  mobileIconSize?: string;
}>`
  ${({ mobileIconSize }) =>
    mobileIconSize &&
    css`
      ${mediaMax.tablet} {
        width: ${mobileIconSize} !important;
        height: ${mobileIconSize} !important;
      }
    `}
`;
